import { emergencyColor } from "./emergency";

const Label = (props: { children: string; emergency?: boolean }) => {
  return (
    <p
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "25px",
        paddingTop: "1px", // Font is a bit off-centered
        // undefined keeps inheriting the navbar's colour
        color: props.emergency ? emergencyColor : undefined,
      }}
    >
      {props.children}
    </p>
  );
};

export { Label };
